import AbstractNode from './AbstractNode';

const tableRowClass = 'top aligned';

export default class TableRow extends AbstractNode {
    get name() {
        return "table_row";
    }

    get markdownToken() {
        return "tr";
    }

    get schema() {
        return {
            content: "(table_cell | table_header)+",
            tableRole: "row",
            parseDOM: [{tag: "table tr"}],
            toDOM: () => ["tr", {'class': tableRowClass}, 0]
        }
    }

    toMarkdown(state, node) {
        state.ensureNewLine();

        let headerRow = false;
        if (node.taskListRow) {
          node.forEach((childNode, _, i) => {
            if (childNode.type.name === 'table_header') {
              headerRow = true;
            }
          });
        }

        if (node.taskListRow && !headerRow) {
          state.write(`<tr class="hidden ${tableRowClass}" data-workflow-id="\${swf:workflowId}" data-task-id="\${swf:taskId}">`);
        } else {
          state.write(`<tr class="${tableRowClass}">`);
        }

        state.ensureNewLine();
        state.renderContent(node);

        state.write('</tr>');

        state.ensureNewLine();
    }

    get parseMarkdown() {
        return {
            block: "table_row"
        }
    }
}